import { AuthProvider, letsStartPage as AuthLetsStartCard } from '@hub-la/fe-auth'

export const LetsStartCardInit = () => {
  return (
    <AuthProvider>
      <AuthLetsStartCard />
    </AuthProvider>
  )
}
